import React from 'react';

import CpdDropdown from '@/components/ui/CpdDropdown';
import { useGetManagedAccounts } from '@/api/hooks/managed-accounts/useGetManagedAccounts';
import { MANAGED_ACCOUNT_TYPE } from '@/views/ManagedAccounts/managedAccount.constants';

const ManagedAccountsDropdown = ({
  value,
  onChange,
  label,
  size = 'small',
  fullWidth = true,
  required = false,
  disabled = false,
  error = false,
  helperText = '',
  variant = 'outlined',
  placeholder,
}) => {
  const { managedAccounts, loading, error: apiError } = useGetManagedAccounts(
    MANAGED_ACCOUNT_TYPE.POSITIVE_PAY,
  );

  return (
    <CpdDropdown
      options={managedAccounts}
      value={value ?? ''}
      onChange={onChange}
      label={label}
      size={size}
      fullWidth={fullWidth}
      required={required}
      disabled={disabled}
      error={error}
      helperText={helperText}
      loading={loading}
      apiError={apiError}
      getOptionLabel={(managedAccount) => managedAccount.name}
      getOptionValue={(managedAccount) => managedAccount.id}
      placeholder={placeholder}
      variant={variant}
    />
  );
};

export default ManagedAccountsDropdown;
